import { createApp } from 'vue';
import homeFeaturedProducts from '../../../vue/home/home-featured-products.vue';

if (document.getElementById('vue-home-featured-products')) {
  const props = {
    shopDomain,
    productBlocks,
  };
  createApp(homeFeaturedProducts, props).mount('#vue-home-featured-products');
}
